export const GLOBAL_ADDRESS = '0x68586851940cC39ab5949c520bB91321d663F975'
// export const TICKET_FACTORY_ADDRESS = '0x6E67544f1Bc749CF6E44aDf95367f110dB16f410'
export const TICKET_FACTORY_ADDRESS = '0x95bA52e0dAAE7178Da31eB8b4Ec43E3EAb0d36Df'
export const TICKET_ADDRESS = '0x8DD4bCA38B6F2169c3329651495850aaa2Ec4b4e'
export const FUNDING_POOL_FACTORY_ADDRESS = '0x237F59848D47D940698C6a70Faf563120240BD44'
// old USDT contract : export const USDT_ADDRESS = '0xb637E978D7661Ff540B845C70CE84Ce448B16902'
export const USDT_ADDRESS = '0xb0ded3cfa42761444bc74d0b8961e01f8aca9e5d'
